module.exports = __webpack_public_path__ + "static/media/Frutiger-Bold.6bc6c79d.otf";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Print/fonts/Frutiger-Bold.otf
// module id = 113
// module chunks = 0